import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { payment } from "../../rbac-consts";
import { default as ClientPaymentContainer } from "./client/PaymentContainer";
import { default as SupportPaymentContainer } from "./support/PaymentContainer";
import { default as AdminPaymentContainer } from "./admin/PaymentContainer";
import { default as SuperAdminPaymentContainer } from "./superAdmin/PaymentContainer";

const PaymentWrapper = () => {

  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={payment.USER}
        yes={() => (
          <ClientPaymentContainer />
        )}
      />
      <Can
        role={user.roles}
        perform={payment.SUPPORT}
        yes={() => (
          <SupportPaymentContainer />
        )}
      />
      <Can
        role={user.roles}
        perform={payment.ADMIN}
        yes={() => (
          <AdminPaymentContainer />
        )}
      />
      <Can
        role={user.roles}
        perform={payment.SUPER_ADMIN}
        yes={() => (
          <SuperAdminPaymentContainer />
        )}
      />
    </>
  );
};

export default PaymentWrapper;